import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiBook, FiCalendar, FiChevronRight } from 'react-icons/fi';
import styles from '../Dashboard.module.css';
import { getStatusIconClass } from './dashboardSummaryHelpers';

// The "My Notes" summary card. Extracted VERBATIM from
// DashboardSummaryCards' render.
export default function NotesSummaryCard({ loaded, navigate, notesSummary, recentNotes }) {
  return (
    <motion.div
      className={styles.summaryCard}
      initial={false}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className={styles.summaryHeader}>
        <h3 className={styles.summaryTitle}>
          <FiBook size={20} />
          My Notes
        </h3>
        <Link
          to="/student/notes"
          className={styles.viewAllButton}
        >
          View All
        </Link>
      </div>
      <div className={styles.summaryContent}>
        <div className={styles.summaryStats}>
          <div className={styles.summaryStatPill}>
            <span className={styles.summaryStatValue}>{notesSummary.total}</span>
            <span className={styles.summaryStatLabel}>Total</span>
          </div>
          <div className={styles.summaryStatPill}>
            <span className={styles.summaryStatValue}>{notesSummary.pinned}</span>
            <span className={styles.summaryStatLabel}>Pinned</span>
          </div>
          <div className={styles.summaryStatPill}>
            <span className={styles.summaryStatValue}>{notesSummary.recent}</span>
            <span className={styles.summaryStatLabel}>Recent</span>
          </div>
        </div>
        <div className={styles.summaryItems}>
          {recentNotes.length > 0 ? (
            recentNotes.map((note, index) => {
              const updatedDate = new Date(note.updated_at).toLocaleDateString();
              return (
                <div
                  key={note.id || `note-${index}`}
                  className={styles.listRow}
                  onClick={() => navigate('/student/notes')}
                  role="button"
                  tabIndex={0}
                  aria-label={`${note.title}, updated ${updatedDate}`}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      navigate('/student/notes');
                    }
                  }}
                >
                <div className={getStatusIconClass('completed')}>
                  <FiBook size={16} />
                </div>
                <div className={styles.rowMain}>
                  <div className={styles.summaryItemTitle}>{note.title}</div>
                  <div className={styles.rowMeta}>
                    <FiCalendar size={12} />
                    Updated: {new Date(note.updated_at).toLocaleDateString()}
                  </div>
                </div>
                <div className={styles.rowChevron}>
                  <FiChevronRight size={16} />
                </div>
              </div>
              );
            })
          ) : loaded ? (
            <div className={styles.emptySummary}>
              <FiBook />
              <p>No notes yet</p>
            </div>
          ) : null}
        </div>
      </div>
    </motion.div>
  );
}
